import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.update-trouble-ticket-mandant-options';
import * as api from '../../../clients/kommunikation';

@Injectable()
export class KommunikationUpdateTroubleTicketMandantOptionsEffects {

    UpdateTroubleTicketMandantOptions$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_UPDATE_TROUBLE_TICKET_MANDANT_OPTIONS),
        mergeMap((x: ac.PostUpdateTroubleTicketMandantOptionsAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postUpdateTroubleTicketMandantOptions(x.troubleTicketMandantOptions).pipe(
                map((result: any) => {
                    return new ac.PostUpdateTroubleTicketMandantOptionsErfolgreichAction(x.troubleTicketMandantOptions, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostUpdateTroubleTicketMandantOptionsFehlerAction(error, x.troubleTicketMandantOptions, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.TroubleTicketCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.TroubleTicketCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.TroubleTicketCommandService);
        }
        return this.service;
    }
}
